/**
 * Converts base64 string to a data URL for image display
 * @param base64 - Base64 encoded image string
 * @param mimeType - MIME type of the image (default: image/jpeg)
 * @returns Data URL string
 */
export function base64ToDataUrl(base64: string, mimeType: string = 'image/jpeg'): string {
  // If it's already a data URL, return as is
  if (base64.startsWith('data:')) {
    return base64;
  }
  
  // Convert base64 to data URL
  return `data:${mimeType};base64,${base64}`;
}
